const initProgressBar = () => {
    const progressBars = document.querySelectorAll<HTMLElement>('.progress-bar');
    if (!progressBars.length) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const bar = entry.target as HTMLElement;
                    const header = bar.querySelector<HTMLElement>('.progress-bar__header');
                    const track = bar.querySelector<HTMLElement>('.progress-bar__track');
                    const fill = bar.querySelector<HTMLElement>('.progress-bar__fill');
                    const percentageObj = bar.querySelector<HTMLElement>('.progress-bar__value');
                    const percentage = bar.getAttribute('data-percentage');

                    if (header) {
                        header.classList.add('is-visible');
                    }

                    if (track) {
                        track.classList.add('is-visible');
                    }

                    if (fill && percentage) {
                        // Slight delay ensures the CSS applies over the initial render
                        setTimeout(() => {
                            fill.style.width = `${percentage}%`;
                        }, 50);

                        if (percentageObj) {
                            let start = 0;
                            const end = parseInt(percentage, 10);
                            const duration = 1500; // ms

                            if (end > 0) {
                                const stepTime = Math.abs(Math.floor(duration / end));

                                setTimeout(() => {
                                    const timer = setInterval(() => {
                                        start += 1;
                                        if (start <= end) {
                                            percentageObj.textContent = `${start}%`;
                                        }
                                        if (start >= end) {
                                            percentageObj.textContent = `${end}%`;
                                            clearInterval(timer);
                                        }
                                    }, stepTime);
                                }, 300); // 300ms delays the counter syncing slightly with the track opening up
                            } else {
                                percentageObj.textContent = '0%';
                            }
                        }
                    }

                    observer.unobserve(bar);
                }
            });
        },
        {
            threshold: 0.2,
        }
    );

    progressBars.forEach((bar) => observer.observe(bar));
};

document.addEventListener('DOMContentLoaded', initProgressBar);
